export default __webpack_public_path__ + "static/media/dashboard.bdffe351.svg";